export default __webpack_public_path__ + "static/media/reinhardt-intro.0fc43bf3.mp3";